<template>
  <div class="china-map">
    <div class="left">
      <v-chart
        ref="map"
        class="charts"
        :options="options"
        @geoselectchanged="handleGeoSelectChanged"
        :style="{ width: '800px', height: '600px' }"
      />
    </div>
    <div
      class="right"
      v-if="data"
    >
      <div class="region-label">
        {{region}}
      </div>
      <div class="region-label">
        培训机构: 共 {{train || "0"}} 家
      </div>
      <div class="region-label">
        服务机构: 共 {{serve || "0"}} 家
      </div>
    </div>
  </div>
</template>

<script>
import VChart from "vue-echarts";
import data from "@/static/data/china.json";
import * as echarts from "echarts";
echarts.registerMap("china", data);
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    VChart
  },
  computed: {
    cityIndex(){
      return data.features.map(
        (item, i) => i
      );
    }
  },
  // eslint-disable-next-line max-lines-per-function
  data(){
    return {
      region: "北京",
      serve: "",
      train: "",
      options: {
        tooltip: {
          show: true,
          trigger: "item"
        },
        geo: {
          map: "china",
          selectedMode: "single",
          itemStyle: {
            normal: {
              borderWidth: 2,
              borderColor: "#fff",
              areaColor: "#d0d0d0",
              label: {
                show: true,
                textStyle: {
                  color: "#0041d6"
                }
              }
            },
            emphasis: {
              borderWidth: 2,
              borderColor: "#ffffff",
              areaColor: "#00349A"
            }
          },
          label: {
            normal: {
              show: true,
              color: "#00349A"
            },
            emphasis: {
              show: true,
              color: "#ffffff"
            }
          }
        }
      }
    };
  },
  methods: {
    handleGeoSelectChanged({ batch }){
      const
        [{ name, selected }] = batch;
      if("南海诸岛" == name){
        this.$refs.map.dispatchAction({
          type: "geoSelect",
          geoIndex: this?.cityIndex
        });
        this.$set(this, "region", "南海诸岛");
      }
      else {
        this.$set(this, "region", name);
      }
      this.$set(this, "serve", this?.data?.[this?.region]?.serve);
      this.$set(this, "train", this?.data?.[this?.region]?.train);
    }
  },
  mounted(){
    this.$watch("data", data => {
      const { serve, train } = data?.[this?.region];
      this.$set(this, "serve", serve);
      this.$set(this, "train", train);
    });
    this.$refs.map.dispatchAction({
      type: "geoSelect",
      name: "北京"
    });
  }
};
</script>

<style lang="less" scoped>
.china-map {
  display: flex;
  .left, .right {
    flex: 1;
  }
  .left {
    min-width: 800px;
    max-width: 800px;
  }
  .right .region-label {
    margin-top: 50px;
    display: inline-block;
    text-align: center;
    background: #4f9ee1;
    border-radius: 20px 0;
    font-size: 28px;
    color: #ffffff;
    line-height: 45px;
    padding: 6px 50px;
    margin-bottom: 20px;
  }
}
</style>